/**
 * Apply Coupon — independent vanilla JS handler.
 * Listens for submit on `[data-coupon-form]` and clicks on `[data-coupon-remove]`.
 * Uses /cart/update.js with the `discount` field. Falls back to refreshing the cart on success.
 */
(function () {
  if (window.__couponHandlerInit) return;
  window.__couponHandlerInit = true;

  const cartUpdateUrl =
    (window.theme && window.theme.routes && window.theme.routes.cart_update_url) ||
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'cart/update.js') ||
    '/cart/update.js';

  function getExistingCodes(form) {
    const pills = form.querySelectorAll('[data-coupon-pill]');
    const codes = [];
    pills.forEach((p) => {
      const c = p.getAttribute('data-discount');
      if (c) codes.push(c);
    });
    return codes;
  }

  function setError(form, message) {
    const alertEl = form.querySelector('[data-coupon-error]');
    const textEl = form.querySelector('[data-coupon-error-text]');
    if (!alertEl) return;
    if (message) {
      if (textEl) textEl.textContent = message;
      alertEl.hidden = false;
    } else {
      alertEl.hidden = true;
      if (textEl) textEl.textContent = '';
    }
  }

  function refreshCart(form, parsedState) {
    const sectionId = form.getAttribute('data-section-id');
    // Try the theme's pubsub system to update cart sections in-place.
    if (
      window.theme &&
      window.theme.pubsub &&
      window.theme.pubsub.publish &&
      window.theme.pubsub.PUB_SUB_EVENTS &&
      window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate
    ) {
      window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-discount',
        cart: parsedState,
      });
      return;
    }
    // Fallback: hard reload the page.
    window.location.reload();
  }

  async function postCart(body) {
    const res = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      throw new Error('HTTP ' + res.status);
    }
    return res.json();
  }

  async function applyCoupon(form) {
    const input = form.querySelector('[name="discount"]');
    const submit = form.querySelector('[type="submit"]');
    if (!input) return;

    const code = (input.value || '').trim();
    if (!code) return;

    const existing = getExistingCodes(form);
    if (existing.includes(code)) {
      setError(
        form,
        (window.theme && window.theme.discountStrings && window.theme.discountStrings.error) ||
          'This coupon code cannot be applied to your cart'
      );
      return;
    }

    setError(form, '');
    if (submit) submit.setAttribute('aria-busy', 'true');

    try {
      const sectionId = form.getAttribute('data-section-id');
      const body = {
        discount: [...existing, code].join(','),
        sections: sectionId ? [sectionId] : undefined,
      };
      const parsed = await postCart(body);

      // Shopify echoes back discount_codes with applicable=false when code is invalid.
      const failed =
        Array.isArray(parsed.discount_codes) &&
        parsed.discount_codes.find(
          (d) => d && d.code && d.code.toLowerCase() === code.toLowerCase() && d.applicable === false
        );
      if (failed) {
        setError(
          form,
          (window.theme && window.theme.discountStrings && window.theme.discountStrings.error) ||
            'This coupon code cannot be applied to your cart'
        );
        input.value = '';
        return;
      }

      // Success: clear and refresh.
      input.value = '';
      refreshCart(form, parsed);
    } catch (err) {
      console.error('[coupon] apply failed:', err);
      setError(form, 'Could not apply coupon. Please try again.');
    } finally {
      if (submit) submit.removeAttribute('aria-busy');
    }
  }

  async function removeCoupon(form, code) {
    if (!code) return;
    const existing = getExistingCodes(form).filter((c) => c !== code);
    setError(form, '');

    try {
      const sectionId = form.getAttribute('data-section-id');
      const body = {
        discount: existing.join(','),
        sections: sectionId ? [sectionId] : undefined,
      };
      const parsed = await postCart(body);
      refreshCart(form, parsed);
    } catch (err) {
      console.error('[coupon] remove failed:', err);
      setError(form, 'Could not remove coupon.');
    }
  }

  // Apply: form submit (covers Enter key + button click).
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target.closest('[data-coupon-form]');
      if (!form) return;
      e.preventDefault();
      applyCoupon(form);
    },
    true
  );

  // Remove pill click.
  document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('[data-coupon-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    const form = removeBtn.closest('[data-coupon-form]');
    if (!form) return;
    const code = removeBtn.getAttribute('data-discount');
    removeCoupon(form, code);
  });
})();
